const NAV_OFFSET_PX = 96;

export function scrollToHomeSection(sectionId) {
  const target = document.getElementById(sectionId);
  if (!target) return false;

  const top = target.getBoundingClientRect().top + window.scrollY - NAV_OFFSET_PX;
  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  return true;
}
